import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "border border-dashed bg-yellow-lp-400 rounded-md py-2 px-4 flex items-center gap-x-4",
  style: {"border-color":"#FAB713","background-image":"linear-gradient(180deg, #FEFAE8, white)"}
}
const _hoisted_2 = { class: "text-12px font-normal" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-semibold" }, " Mohon sampaikan informasi ini ke customer ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      src: require(`@/app/ui/assets/svg/hourglass-illustration.svg`),
      alt: "info"
    }, null, 8, ["src"]),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("p", null, " Paket akan dikirim dengan armada " + _toDisplayString(_ctx.translatedCargoType) + " & estimasi paket sampai tujuan " + _toDisplayString(_ctx.slaMin) + " - " + _toDisplayString(_ctx.slaMax) + " hari ", 1)
    ])
  ]))
}